module.exports = __webpack_public_path__ + "static/media/S (131).6086aad2.jpg";